import axios from "axios";

const UPLOAD_API_BASE_URL =
  process.env.REACT_APP_UPLOAD_API_URL;

/**
 * Upload a file to the REST upload API. Supports images and videos.
 * @param {File} file - The file to upload
 * @returns {Promise<string>} - The imageUploadUrl from the response (URL to store)
 */
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${UPLOAD_API_BASE_URL}/uploadFile`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  const data = response.data;
  if (response.status !== 200 || (data.error !== 0 && data.error !== undefined)) {
    const message = data.message || (data.error != null ? String(data.error) : "File upload failed");
    throw new Error(typeof message === "string" ? message : "File upload failed");
  }

  if (!data.imageUploadUrl) {
    throw new Error("Upload succeeded but no imageUploadUrl in response");
  }

  return data.imageUploadUrl;
};

export default { uploadFile };
